import equipmentModel from '../../../../model/equipment';
import equipmentFactoryModel from '../../../../model/equipmentFactory';
import Loading from './../misc/Loading';
import EquipmentGroupComponent from './EquipmentGroup';
import update from 'immutability-helper';
import React from 'react';
import ValidationError from '../../../../model/error/ValidationError';
import modelModel from '../../../../model/model';
import withRouter from '/src/components/misc/withRouter';

const errorToMessage = (error) => {
  console.error(error);
  if (error instanceof ValidationError) {
    return 'Gruppen validerer ikke og kan dermed ikke publiseres. Sjekk at alle påkrevede felter er fylt ut med gyldige verdier og prøv igjen.';
  }

  return 'En ukjent feil inntraff ved behandling av gruppen og handlingen kunne dermed ikke fullføres.';
};

class EquipmentGroupContainer extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      equipmentGroup: null,
      modified: false,
      working: false,
      error: null
    };

    this.model = this.props.match.params.type === 'equipment' ? equipmentModel : equipmentFactoryModel;

    this.handlePublish = this.handlePublish.bind(this);
    this.handleUnpublish = this.handleUnpublish.bind(this);
    this.handleSave = this.handleSave.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleArchive = this.handleArchive.bind(this);
    this.handleUnArchive = this.handleUnArchive.bind(this);
  }

  componentDidMount() {
    let equipmentgroupid = null;

    if (this.props.match.params.equipmentgroupid && this.props.match.params.equipmentgroupid !== 'new') {
      equipmentgroupid = this.props.match.params.equipmentgroupid;
    }

    if (equipmentgroupid) {
      this.model.getById(this.props.match.params.equipmentgroupid, 2).then((equipmentGroup) => {
        document.title = `Admin - Gruppe - ${equipmentGroup.name}`;
        this.setState({
          equipmentGroup: equipmentGroup,
          model: equipmentGroup.model
        });
      }).catch((e) => {
        this.setState({
          error: errorToMessage(e),
          working: false
        });
      });
    } else if (this.props.match.params.modelId && this.props.match.params.type) {
      Promise.all([
        this.model.initializeCustom(1),
        modelModel.getById(this.props.match.params.modelId, 1)
      ]).then(([equipmentGroup, model]) => {
        equipmentGroup.group = true;

        this.setState({
          equipmentGroup: equipmentGroup,
          model: model
        });
      }).catch((e) => {
        this.setState({
          error: errorToMessage(e),
          working: false
        });
      });
    }
  }

  handleSave() {
    this.setState({
      error: null,
      working: true,
      modified: false
    });

    const isCreate = !this.state.equipmentGroup.id;
    if (isCreate) {
      this.model.create({
        ...this.state.equipmentGroup,
        modelId: this.state.model.id
      }, 2).then((equipmentGroup) => {
        this.setState({
          working: false,
          equipmentGroup: equipmentGroup
        });
        this.props.history.push(`/equipmentGroup/${this.props.match.params.type}/${equipmentGroup.id}`);
      }).catch((e) => {
        this.setState({
          error: errorToMessage(e),
          working: false
        });
      });
    } else {
      this.model.save(this.state.equipmentGroup, 2).then((equipmentGroup) => {
        this.setState({
          working: false,
          equipmentGroup: equipmentGroup
        });
      }).catch((e) => {
        this.setState({
          error: errorToMessage(e),
          working: false
        });
      });
    }
  }

  handlePublish() {
    this.setState({
      working: true
    });
    this.model.publish(this.state.equipmentGroup.id, 2).then((equipmentGroup) => {
      this.setState({
        working: false,
        equipmentGroup: equipmentGroup
      });
    }).catch((e) => {
      this.setState({
        error: errorToMessage(e),
        working: false
      });
    });
  }

  handleUnpublish() {
    this.setState({
      working: true
    });
    this.model.unpublish(this.state.equipmentGroup.id, 2).then((equipmentGroup) => {
      this.setState({
        working: false,
        equipmentGroup: equipmentGroup
      });
    }).catch((e) => {
      this.setState({
        error: errorToMessage(e),
        working: false
      });
    });
  }

  handleArchive() {
    this.setState({
      working: true
    });
    this.model.archive(this.state.equipmentGroup.id, 2).then((equipmentGroup) => {
      this.setState({
        working: false,
        equipmentGroup: equipmentGroup
      });
    }).catch((e) => {
      this.setState({
        error: errorToMessage(e),
        working: false
      });
    });
  }

  handleUnArchive() {
    this.setState({
      working: true
    });
    this.model.unarchive(this.state.equipmentGroup.id, 2).then((equipmentGroup) => {
      this.setState({
        working: false,
        equipmentGroup: equipmentGroup
      });
    }).catch((e) => {
      this.setState({
        error: errorToMessage(e),
        working: false
      });
    });
  }

  handleChange(props, ValidateLastAdded) {
    const state = update(props, {
      modified: {
        $set: true
      }
    });

    if (!ValidateLastAdded) {
      this.setState(state);
    } else {
      // Check that added item is not in another group, which is not supporter, nor makes sense.
      let lastAdded;
      if (this.props.match.params.type === 'equipment') {
        lastAdded = props.equipmentGroup.includedEquipment[props.equipmentGroup.includedEquipment.length - 1];
      } else {
        lastAdded = props.equipmentGroup.includedFactoryEquipment[props.equipmentGroup.includedFactoryEquipment.length - 1];
      }

      this.model.getLinkedEntries(lastAdded.id).then((linkedEntries) => {
        const isAlreadyInAGroup = linkedEntries.some((entry) => {
          if (!['equipment', 'equipmentFactory'].includes(entry.sys.contentType.sys.id)) {
            return false;
          }

          // Make sure it is not this group. I.e. it has been removed and added back without a save between.
          if (entry.sys.id === this.state.equipmentGroup.id) {
            return false;
          }

          return entry.fields.group;
        });

        if (!isAlreadyInAGroup) {
          this.setState(state);
        } else {
          this.setState({
            error: 'Utstyr du prøvde å legge til ligger allerede i en annen gruppe og ble ikke lagt til. Utstyr kan kun ligge i en gruppe om gangen.'
          });
        }
      });
    }
  }

  render() {
    if (!this.state.equipmentGroup) {
      return <Loading title="Gruppe" text="Laster..." />;
    }

    return (
      <EquipmentGroupComponent
        equipmentGroup={this.state.equipmentGroup}
        model={this.state.model}
        type={this.props.match.params.type}
        modified={this.state.modified}
        working={this.state.working}
        error={this.state.error}
        onChange={this.handleChange}
        onSave={this.handleSave}
        onPublish={this.handlePublish}
        onUnpublish={this.handleUnpublish}
        onArchive={this.handleArchive}
        onUnArchive={this.handleUnArchive}
      />
    );
  }
}

EquipmentGroupContainer.defaultProps = {
  id: null
};

export default withRouter(EquipmentGroupContainer);
